class ConsultaTributaria {
    static get $inject() {
        return ['api']
    }

    constructor(api) {
        this.api = api
    }

    consultaTributacao(filtro) {
        return this
            .api
            .get('/eficiencia-fiscal/auditoria-tributaria-ncm/', filtro)
            .then(({ data: { data, success, message } }) => {
                if (success) {
                    return {
                        correlacionadas: data.correlacionadas || [],
                        farmaceutico: data.farmaceutico,
                        pisCofins: data.retorno_pis_cofins,
                        icms: data.retorno_icms,
                        ncms: data.retorno_ncm,
                        cest: data.cests,
                        hasPisCofins: data.has_pis_cofins,
                        hasIcms: data.has_icms,
                    }
                } else {
                    this.correlacionadas = data ? data.correlacionadas : null
                    return Promise.reject(message)
                }
            })
    }
}

angular.module('eficienciaFiscalModule').service('ConsultaTributaria', ConsultaTributaria)
